import React from 'react'
import contactSvg from '../assets/svg/contact.svg'
export default function Hero() {
  return (
    <>
 <div className="relative h-full pb-10 md:pb-48 flex items-center">
 <div className="intro">
    <img src={contactSvg} className="w-full h-full absolute object-cover opacity-30" />
    </div>
    <div className="container pt-20 px-2 md:px-10 m-auto">
    <div className="items-center h-full flex flex-col justify-center p-2 md:p-6 mx-auto  lg:flex-row lg:justify-between ">
    <div className="space-y-5 w-full text-center items-end md:text-left md:w-1/2 relative bottom-0 md:bottom-12">
        <h1 className="text-3xl md:text-5xl font-bold  text-white ">
        Searchable LMIA Database
    
        </h1>
              <p className='text-white text-sm md:text-lg text-normal leading-5leading-8'>
              LMIA.LTD provides a seamless and user-friendly search experience for accessing a
  comprehensive database of employers who have received positive or negative Labour
  Market Impact Assessment (LMIA) reports from Employment and Social Development
  Canada (ESDC).
              </p>
        
      
      </div>
          <div className="w-full md:w-1/2  text-right relative ">
        <img src="https://mambaui.com/assets/svg/Business_SVG.svg" alt="" className="object-contain relative left-0 md:left-16 top-0  " />
      </div>
      </div>
    </div>
   
 </div>
    </>
  )
}
